import { Component, OnInit, Input } from "@angular/core";
import { TopNavBtn } from "../../classes/navbar";

@Component({
  selector: "top-nav-btn-inner",
  templateUrl: "./top-nav-btn-inner.component.html",
  styleUrls: ["./top-nav-btn-inner.component.scss"],
})
export class TopNavBtnInnerComponent implements OnInit {
  @Input() btnDetails: TopNavBtn;
  @Input() isBolded: boolean;

  partialImagePath: string = "../../assets/images/";

  constructor() {}

  ngOnInit() {}
}
